var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234.2771 276.3632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72abe1;\n      }\n\n      .cls-2 {\n        fill: #3a6bbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.3217,211.4078c-1.2636,36.0876-30.9172,64.9554-67.3127,64.9554h-37.0961v-64.9129h102.0199c.7963,0,1.5926-.0213,2.3889-.0425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.364,52.8386v54.1604h-102.0197c-.7963,0-1.5926.0109-2.3889.0425,1.2634-36.0982,30.9169-64.9661,67.3124-64.9661h26.333c5.9443,0,10.7632,4.8188,10.7632,10.7632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.7147,106.999c4.1766,0,7.5625,3.3858,7.5625,7.5625v29.5339c0,36.3955-28.8681,66.049-64.9554,67.3124.0316-.7963.0423-1.5926.0423-2.3995v-102.0093h57.3507Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.9554,107.0415c-.0319.7857-.0425,1.5926-.0425,2.3889v102.0199H10.8145c-5.9727,0-10.8145-4.8418-10.8145-10.8145v-26.2923c0-36.3955,28.8679-66.049,64.9554-67.302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m169.364,106.999v102.0093c0,.8069-.0106,1.6032-.0423,2.3995-.7963.0213-1.5926.0425-2.3889.0425h-102.0199v-102.0199c0-.7963.0106-1.6032.0425-2.3889.7963-.0316,1.5926-.0425,2.3889-.0425h102.0197Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.1504,
    cy: 23.085,
    r: 23.085
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.aa91455daa8e8ba4932a91d8c15ec156.svg";
export { ForwardRef as ReactComponent };